import { faEnvelope, faReceipt } from "@fortawesome/pro-regular-svg-icons";

import { T } from "@repo/transifex";
import { LogoRocket } from "~/components/kiosk/svgs/rocket";
import { DEFAULT_MODAL_DURATION_MS } from "~/components/kiosk/ui/modals/constants";

import { Modal } from "../shared/modal";
import { ModalButton } from "../shared/modal-button";
import { ModalButtonGroup } from "../shared/modal-button-group";
import { ModalTitle } from "../shared/modal-title";

type ModalOrderConfirmationProps = {
  onClose: () => void;
  onPrintReceipt: (() => void) | null;
  onSendReceipt: () => void;
  timeoutDuration?: number;
};

export const ModalOrderConfirmation = ({
  onClose,
  onPrintReceipt,
  onSendReceipt,
  timeoutDuration = DEFAULT_MODAL_DURATION_MS
}: ModalOrderConfirmationProps) => {
  return (
    <Modal open backdropVariant="success">
      <div className="flex flex-col items-center justify-center gap-y-16 px-40 text-center">
        <LogoRocket />

        <ModalTitle size="8xl" variant="normal" weight="black">
          <T _str="Your order is confirmed" />
        </ModalTitle>

        <p className="text-5xl font-extralight text-kiosk-text-primary">
          <T _str="Do you want a receipt?" />
        </p>

        <ModalButtonGroup>
          <ModalButton
            hidden={onPrintReceipt === null}
            onClick={() => onPrintReceipt?.()}
            variant="success"
            icon={faReceipt}
            size="medium"
          >
            <T _str="Print receipt" />
          </ModalButton>

          <ModalButton
            onClick={onSendReceipt}
            variant="success"
            icon={faEnvelope}
            size="medium"
          >
            <T _str="Send receipt" />
          </ModalButton>
        </ModalButtonGroup>

        <ModalButton
          onClick={onClose}
          variant="success"
          size="medium"
          timeoutDuration={timeoutDuration}
        >
          <T _str="Close" />
        </ModalButton>
      </div>
    </Modal>
  );
};
